import React from 'react';

// 스타일(CSS) 정의 - 애니메이션 재사용
const styles = `
  .aaron-float { animation: aaron-float 3s ease-in-out infinite; }
  @keyframes aaron-float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-4px); } }
  .aaron-blink { animation: aaron-blink 4s infinite; transform-origin: center; }
  @keyframes aaron-blink { 0%, 96%, 100% { transform: scaleY(1); } 98% { transform: scaleY(0.1); } }
  .aaron-wave { animation: aaron-wave 2.5s ease-in-out infinite; transform-origin: 70px 75px; } 
  @keyframes aaron-wave { 0%, 100% { transform: rotate(0deg); } 50% { transform: rotate(15deg); } }
  .talking-mouth { animation: elastic-talk 0.2s infinite alternate ease-in-out; transform-box: fill-box; transform-origin: center; }
  @keyframes elastic-talk { 0% { transform: scale(1, 1) translateY(0); } 100% { transform: scale(0.85, 1.5) translateY(1.5px); } }
`;

export default function AaronFace({ size = 100, isTalking = false, eyePosition = { x: 0, y: 0 } }) {
    return (
        <div style={{ width: size, height: size }} className="relative">
            <style>{styles}</style>
            <div className="w-full h-full rounded-full shadow-xl flex items-center justify-center relative overflow-hidden group">
                <svg width="100%" height="100%" viewBox="0 0 100 100" fill="none" className="aaron-float">
                    <defs><clipPath id="widget-circle"><circle cx="50" cy="50" r="50" /></clipPath></defs>
                    <g clipPath="url(#widget-circle)">
                        <rect x="0" y="0" width="100" height="100" fill="#2C3E30" />
                        <path d="M-10 -10 H110 V38 Q50 50 -10 38 Z" fill="white" />
                    </g>
                    <path d="M2 38 Q 50 50 98 38 Q 98 44 94 46 Q 50 58 6 46 Q 2 44 2 38 Z" fill="#60A5FA" />
                    <circle cx="50" cy="50" r="3.5" fill="#FBBF24" stroke="#D97706" strokeWidth="0.5" />

                    {/* Eyes Container with Transform */}
                    <g transform={`translate(${eyePosition.x}, ${eyePosition.y})`}>
                        <g className="aaron-blink">
                            <circle cx="36" cy="64" r="4.5" fill="white" />
                            <circle cx="64" cy="64" r="4.5" fill="white" />
                        </g>
                    </g>

                    <path d="M42 75 C42 75 50 80 58 75" stroke="white" strokeWidth="3" strokeLinecap="round" className={isTalking ? "talking-mouth" : ""} />
                    <circle cx="28" cy="70" r="3.5" fill="#F87171" opacity="0.3" />
                    <circle cx="72" cy="70" r="3.5" fill="#F87171" opacity="0.3" />
                    <g className="aaron-wave">
                        <path d="M82 88 V40 C82 28 94 28 94 40" stroke="#FBBF24" strokeWidth="5" strokeLinecap="round" />
                        <circle cx="82" cy="72" r="8.5" fill="white" />
                        <path d="M82 67 C82 67 86 69 85 73" stroke="#CBD5E1" strokeWidth="2" strokeLinecap="round" />
                    </g>
                </svg>
            </div>
        </div>
    );
}
